<template>
  <div class="text-center mt-5">
    <h2>{{ message }}</h2>
    <router-link to="/wallet/recharge">← Back to Recharge</router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: "Verifying payment...",
      loading: true,
    };
  },
  mounted() {
    const tranId = this.$route.query.tran_id;
    const message = this.$route.query.message;
    if (tranId) {
      this.message =
        "MiME wallet recharge is successful. Your wallet balance will be updated within 2-5 minutes";
      this.loading = false;
    } else {
      this.message = message || "Invalid transaction.";
      this.loading = false;
    }
  },
};
</script>
